import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiSharpenProposal(markdown: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a sales copywriter specializing in consulting proposals. Strengthen this proposal: tighten the problem framing, make the cost-of-inaction visceral, sharpen the differentiators, and improve the call to action. Keep all factual content. Output the full polished proposal in Markdown.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: markdown }],
      temperature: 0.4, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
